import React, { useState } from "react";
import { Link } from "react-router-dom";

const BasisTableComponent = ({ columns, data, pagination, onPageChange, title = "قائمة البيانات" }) => {
  const useExternalPagination = !!pagination;

  const [currentPage, setCurrentPage] = useState(0);
  const rowsPerPage = 5;

  const page = useExternalPagination ? pagination.page - 1 : currentPage;
  const totalPages = useExternalPagination
    ? pagination.pages
    : Math.ceil(data.length / rowsPerPage);

  const paginatedData = useExternalPagination
    ? data
    : data.slice(page * rowsPerPage, (page + 1) * rowsPerPage);

  const handlePageChange = (newPage) => {
    if (useExternalPagination) {
      onPageChange?.(newPage);
    } else {
      setCurrentPage(newPage);
    }
  };

  const handleCompare = (row) => {
    let id = null;
    console.log(row)
    row.program_id ? id = row.program_id :  id = row.id;
    window.location.href = `/programs/compare/${id}`;
  };
  
  const handleViewDetails = (row) => {
    window.location.href = `/programs/details/${row.id}`;
  };
  

  return (
    <div className="col-12">
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">{title}</h4>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <div className="dataTables_wrapper" id="job_data">
              <table className="display w-100 dataTable">
                <thead>
                  <tr>
                    {columns.map((col, idx) => (
                      <th key={idx} className="text-center">{col.label}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {paginatedData.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      {columns.map((col, colIndex) => (
                    <td className="text-center" key={colIndex}>
                    {col.render ? col.render(row) : (
                      col.field === "classification" ? (
                        <span className={`badge badge-${
                          {
                            excellent: "success",
                            good: "info",
                            acceptable: "secondary",
                            weak: "danger",
                          }[row[col.field]?.toLowerCase()] || "light"
                        }`}>
                          {row[col.field]}
                        </span>
                      ) : col.field === "actions" ? (
                        <>
                          <button
                            className="btn btn-sm btn-outline-primary"
                            style={{ marginLeft: "5px" }}
                            onClick={() => handleCompare(row)}
                          >
                            تفاصيل
                          </button>
                        </>
                      ) : (
                        row[col.field]
                      )
                    )}
                  </td>
                  
                   

                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                <div className="dataTables_info">
                  {useExternalPagination ? (
                    <>عرض الصفحة {pagination.page} من {pagination.pages}</>
                  ) : (
                    <>
                      عرض {currentPage * rowsPerPage + 1} إلى{" "}
                      {Math.min((currentPage + 1) * rowsPerPage, data.length)} من{" "}
                      {data.length} مُدخل
                    </>
                  )}
                </div>
                <div className="dataTables_paginate paging_simple_numbers">
                  <button
                    className="paginate_button previous"
                    disabled={page + 1 === 1}
                    onClick={() => handlePageChange(page)}
                  >
                    السابق
                  </button>
                  <span>
                    {Array.from({ length: totalPages }, (_, i) => (
                      <button
                        key={i}
                        className={`paginate_button ${
                          page === i ? "current" : ""
                        }`}
                        onClick={() => handlePageChange(i + 1)}
                      >
                        {i + 1}
                      </button>
                    ))}
                  </span>
                  <button
                    className="paginate_button next"
                    disabled={page + 1 === totalPages}
                    onClick={() => handlePageChange(page + 2)}
                  >
                    التالي
                  </button>
                </div>
              </div>
              {/* End Pagination */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasisTableComponent;
